import Components from './Formula.vue';

const formula = {
    install:function(Vue) {
        Vue.component('formula', Components)
    }
}

export default formula;